<section class="comp-org-general-info">
  <form #generalForm="ngForm">

    <div *ngIf="partner">
      <div class="p-grid" style="padding-bottom:20px;border-bottom:1px solid #ccc;background-color:#F8F8FF;margin-bottom:20px;">
        <div class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label>Is Active?</label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              <p-selectButton name="isActive" [options]="viewOptions"
                              [(ngModel)]="partner.active"
                              [disabled]="!currentTxnStatus.saveEnabled"></p-selectButton>
            </div>
          </div>
        </div>

        <div *ngIf="orgType===OrgType.Vendor " class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label>Is Vendor Your Employee? </label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              <p-checkbox name="vendorEmployee" binary="true" [style]="{'padding':'8px 0 0 0','margin-left':'5px'}"
                          [(ngModel)]="partner.isEmployee"
                          (onChange)="isVendorYourEmployee(partner.isEmployee)"
                          [disabled]="!currentTxnStatus.saveEnabled"></p-checkbox>
              <p-autoComplete *ngIf="partner.isEmployee"
                              name="fullName" class="autoComplete" field="fullName" [minLength]="Validation.AutoCompleteMinLength"
                              [placeholder]="Validation.AutoCompletePlaceholder" [showEmptyMessage]="true" [suggestions]="userAutoCompleteOptions"
                              [(ngModel)]="vendorEmployee"
                              (completeMethod)="searchUser($event.query)"
                              (onSelect)="onSelectUser(vendorEmployee)"
                              [disabled]="!currentTxnStatus.saveEnabled"></p-autoComplete>
            </div>
          </div>
        </div>

        <div class="p-col-12 p-md-6 p-lg-6">
          <div *ngIf="orgType===OrgType.Vendor " class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label>Submitted For*</label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              <app-submitted-for [txnType]=TxnType.Vendor [submittedForId]="this.selectedSubmittedForId"
                                 (handler)="loadDelegate($event)"
                                 [editable]="currentTxnStatus.saveEnabled">
              </app-submitted-for>
            </div>
          </div>
        </div>

        <div *ngIf="orgType===OrgType.Vendor" class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label>Vendor PDF Template* </label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              <app-pdf-template-dropdown [txnType]=TxnType.Vendor [templateId]="partner.pdfTemplateId"
                                         (handler)="onChangePdfTemplate($event)"
                                         [disabled]="!currentTxnStatus.saveEnabled"></app-pdf-template-dropdown>
            </div>
          </div>
        </div>

        <div *ngIf="orgType===OrgType.Customer " class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label>Submitted For* </label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              <app-submitted-for [txnType]="TxnType.Customer" [submittedForId]="this.selectedSubmittedForId"
                                 (handler)="loadDelegate($event)"
                                 [editable]="currentTxnStatus.saveEnabled"></app-submitted-for>
            </div>
          </div>
        </div>

        <div *ngIf="orgType===OrgType.Customer" class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label>Customer PDF Template*</label></div>
            <div class="p-col-12 p-md-8 p-lg-8">
              <app-pdf-template-dropdown [txnType]="TxnType.Customer" [templateId]="partner.pdfTemplateId"
                                         (handler)="onChangePdfTemplate($event)"
                                         [disabled]="!currentTxnStatus.saveEnabled">
              </app-pdf-template-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-grid">
      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Current Balance</label></div>
          <div *ngIf="partner.currentBalance" class="p-col-12 p-md-8 p-lg-8">
            <span style="position:relative;top:10px;">{{partner.currentBalance | currency:Format.Currency}}</span>
          </div>

          <div *ngIf="!partner.currentBalance" class="p-col-12 p-md-8 p-lg-8">
            <span style="position:relative;top:10px;"> $0.00</span>
          </div>
        </div>
      </div>

      <div *ngIf="orgType===OrgType.Vendor" class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>1099 Required?</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-selectButton name="require1099" [options]="viewOptions"
                            [(ngModel)]="partner.require1099"
                            [disabled]="!currentTxnStatus.saveEnabled"></p-selectButton>
          </div>
        </div>
      </div>

      <div *ngIf="orgType===OrgType.Customer" class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <label class="p-col-12 p-md-4 p-lg-4">Is Government Agency? <i class="fa fa-info-circle" pTooltip="Payment Terms are not applicable for Government Agencies, System defaults these values."
                                                                         tooltipPosition="top" style="padding-left:10px;">
          </i></label>

          <div class="p-col-12 p-md-8 p-lg-8">
            <p-selectButton name="governmentAgency"
                            [options]="viewOptions"
                            [(ngModel)]="partner.governmentAgency"
                            (onChange)="enableTaxFields($event.value)"
                            [disabled]="!currentTxnStatus.saveEnabled"></p-selectButton>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Account # </label>
          </div>
          <div *ngIf="partner?.partnerPaymentSettings?.length>=1&&partner.partnerPaymentSettings[0].displayAccountNumber"
               class="p-col-12 p-md-8 p-lg-8" style="margin-top:10px">{{partner.partnerPaymentSettings[0].displayAccountNumber}}
          </div>
        </div>
      </div>

      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Doing Business As (DBA)?</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-selectButton name="isDBA"
                            [options]="viewOptions"
                            [(ngModel)]="partner.enableDBA"
                            (onChange)="onChangeEnableDBA(partner.enableDBA)"
                            [disabled]="!currentTxnStatus.saveEnabled"></p-selectButton>
          </div>
        </div>
      </div>

      <div *ngIf="orgType===OrgType.Vendor && partner?.require1099" class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Tax Number
              <span>*</span>
            </label></div>
          <div class="p-col-12 p-md-8 p-lg-8 vendor-radio">

            <p-radioButton name="groupTaxNumber" value="ssn" inputId="opt1" label="SSN"
                           [(ngModel)]="selectedTaxOptionValue"
                           [disabled]="!currentTxnStatus.saveEnabled"
                           (onClick)="onSelectSSN()"></p-radioButton>&nbsp;
            <p-radioButton name="groupTaxNumber" value="ein" inputId="opt2" label="EIN"
                           [(ngModel)]="selectedTaxOptionValue"
                           [disabled]="!currentTxnStatus.saveEnabled"
                           (onClick)="onSelectEIN()"></p-radioButton>
            <div style="margin-top:5px;">
              <span *ngIf="partner?.isSsn">
                <span *ngIf="partner.id">
                  <span *ngIf="showEditSSN" class="ssn-masking">
                    <p-inputMask name="taxNumber" mask="999-99-9999" [unmask]="true" [maxlength]=Validation.TaxNumberMaxLength
                                 placeholder="999-99-9999"
                                 [(ngModel)]="partner.taxNumber" required></p-inputMask>
                    <button pButton class="icon-action" icon="fa fa-check"
                            (click)="showEditSSN = !showEditSSN"
                            [disabled]="9 > partner.taxNumber?.length || !currentTxnStatus.saveEnabled"></button>
                  </span>
                  <span *ngIf="!showEditSSN" class="ssn-masking">
                    {{partner.taxNumber | ssnMask}}
                    <button pButton class="icon-action" icon="fa fa-pencil"
                            (click)="showEditSSN = !showEditSSN"></button>
                  </span>
                </span>
                <span *ngIf="!partner.id">
                  <p-inputMask name="taxNumber" mask="999-99-9999" [unmask]="true" [maxlength]="Validation.TaxNumberMaxLength"
                               placeholder="999-99-9999"
                               [(ngModel)]="partner.taxNumber" [disabled]="!currentTxnStatus.saveEnabled" required></p-inputMask>
                </span>

              </span>
              <p-inputMask *ngIf="!partner?.isSsn"
                           name="taxNumber" mask="99-9999999" [unmask]="true" [maxlength]="Validation.TaxNumberMaxLength"
                           placeholder="99-9999999"
                           [(ngModel)]="partner.taxNumber" [disabled]="!currentTxnStatus.saveEnabled" required></p-inputMask>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="p-col-12" style="margin-bottom:0;"><h3 style="margin-bottom:0;">Business Information</h3></div>
    <div class="p-grid main-info">
      <div class="p-col-12 p-md-6 p-lg-6 main-info-primary">
        <div *ngIf="partner" class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Legal Name*</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText name="tpBusinessName" type="text" [size]="Validation.DialogTextSize" [maxlength]="Validation.nameMaxLength"
                   [(ngModel)]="partner.businessName"
                   [disabled]="!currentTxnStatus.saveEnabled" required>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Address Name*</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">

            <input pInputText name="tpAddrName" type="text" [size]="Validation.DialogTextSize" [maxlength]="Validation.nameMaxLength"
                   [(ngModel)]="mainPartnerAddress.addrName"
                   (input)="onChangeUpdateBillingAddress()"
                   [disabled]="!currentTxnStatus.saveEnabled" required>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Address*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText name="tpAddressLn1" type="text" [size]="Validation.DialogTextSize" [maxlength]="Validation.AddrMaxLength"
                   [(ngModel)]="mainPartnerAddress.addrLn1"
                   (input)="onChangeUpdateBillingAddress()"
                   [disabled]="!currentTxnStatus.saveEnabled" required>
            <br>
            <input pInputText name="tpAddressLn2" type="text" class="text-wrapper-address" [size]="Validation.DialogTextSize" [maxlength]="Validation.AddrMaxLength" style="margin-top:5px;"
                   [(ngModel)]="mainPartnerAddress.addrLn2"
                   (input)="onChangeUpdateBillingAddress()"
                   [disabled]="!currentTxnStatus.saveEnabled">
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>City*</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText name="tpCity" type="text" [size]="Validation.DialogTextSize" [maxlength]="Validation.CityMaxLength"
                   [(ngModel)]="mainPartnerAddress.city"
                   (input)="onChangeUpdateBillingAddress()"
                   [disabled]="!currentTxnStatus.saveEnabled" required>
          </div>
        </div>

        <div *ngIf="mainPartnerAddress.country===CountryType.USA" class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>
              State*</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown name="tpState" [placeholder]="PrimeNgConfig.DropdownPlaceholder"
                        [options]="stateCodesDropdown" filter="true"
                        [(ngModel)]="mainPartnerAddress.stateCode"
                        (onChange)="onChangeUpdateBillingAddress()"
                        [disabled]="!currentTxnStatus.saveEnabled" required></p-dropdown>
          </div>
        </div>

        <div *ngIf="mainPartnerAddress.country!==CountryType.USA" class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>State/Province/Region*</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText name="tpRegion" type="text" pKeyFilter="alpha" [maxLength]="Validation.StateNameMaxLength"
                   [(ngModel)]="mainPartnerAddress.stateCode"
                   (input)="onChangeUpdateBillingAddress()"
                   [disabled]="!currentTxnStatus.saveEnabled" required>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Zip Code*</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input *ngIf="mainPartnerAddress.country===CountryType.USA"
                   pInputText name="tpZip" type="text" [pattern]="UsZipCodePattern" pKeyFilter="pnum" [minlength]="Validation.UsZipMinLength"
                   [maxlength]="Validation.UsZipMaxLength"
                   [(ngModel)]="mainPartnerAddress.postalCode"
                   (input)="onChangeUpdateBillingAddress()"
                   [disabled]="!currentTxnStatus.saveEnabled" required>

            <input *ngIf="mainPartnerAddress.country!==CountryType.USA"
                   pInputText name="tpPostal" type="text" [pattern]="AlphaNumDashRegex" pKeyFilter="pnum" [minlength]="Validation.NonUsZipMinLength" [maxlength]="Validation.NonUsZipMaxLength"
                   [(ngModel)]="mainPartnerAddress.postalCode"
                   (input)="onChangeUpdateBillingAddress()"
                   [disabled]="!currentTxnStatus.saveEnabled" required>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Country*</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown name="tpCountry" [placeholder]="PrimeNgConfig.DropdownPlaceholder"
                        [options]="countryCodesDropdown" filter="true"
                        [(ngModel)]="mainPartnerAddress.country"
                        (onChange)="onChangeUpdateBillingAddress()"
                        [disabled]="!currentTxnStatus.saveEnabled" required></p-dropdown>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-lg-6 main-info-secondary">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Main Phone*</label></div>
          <div class="p-col-12 p-md-8 p-lg-8" [ngStyle]="{'pointer-events':(!currentTxnStatus.saveEnabled) ? 'none' : 'auto' }">
            <!--                FixMe jC:-->
            <!--                Support for using the ngModel input property and ngModelChange event with reactive form directives has been deprecated in v6 and removed in v7.-->
            <!--                ngModelChange is now emitted after the value/validity is updated on its control instead of before to better match expectations.
                                If you rely on the order of these events, you will need to begin tracking the old value in your component.-->

            <app-international-phone-number name="tpMainPhone"
                                            [(ngModel)]="mainPartnerAddress.mainPhone"
                                            (handleChange)="onChangeUpdateBillingAddress()"
                                            required></app-international-phone-number>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Fax Phone </label></div>
          <div class="p-col-12 p-md-8 p-lg-8" [ngStyle]="{'pointer-events':(!currentTxnStatus.saveEnabled) ? 'none' : 'auto' }">
            <app-international-phone-number name="tpFaxPhone"
                                            [(ngModel)]="mainPartnerAddress.faxPhone"
                                            (handleChange)="onChangeUpdateBillingAddress()"></app-international-phone-number>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>DUNS Code</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-inputMask name="tpDunsNumber" mask="999999999" [unmask]="true" [minlength]="Validation.DunsNumberMaxLength"
                         [maxlength]="Validation.DunsNumberMaxLength" placeholder="999999999"
                         [(ngModel)]="partner.dunsNumber"
                         [disabled]="!currentTxnStatus.saveEnabled"></p-inputMask>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>CAGE Code</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-inputMask name="tpCageCode" mask="*****" [unmask]="true" [minlength]="Validation.CageCodeMaxLength" [maxlength]="Validation.CageCodeMaxLength" placeholder="XYZ10"
                         [(ngModel)]="partner.cageCode"
                         [disabled]="!currentTxnStatus.saveEnabled"></p-inputMask>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Website</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText name="website" type="text" [pattern]="RegExpWebsite" [size]="Validation.DialogTextSize" [maxlength]="Validation.websiteURL" placeholder="www.abc.com"
                   [(ngModel)]="partner.website"
                   [disabled]="!currentTxnStatus.saveEnabled">
          </div>
        </div>
      </div>
    </div>
    <div class="p-col-12 dba-flow">

      <div *ngIf="partner.enableDBA" class="p-col-12">
        <div class="p-col-12" style="text-align:left;"><h3 style="display:inline;margin-right:20px;">DBA Information</h3>
          <button pButton type="button" class="action-secondary" icon="fa fa-copy" label="Copy from Business Information"
                  (click)="onClickCopyMainToDbaAddress(partner)"
                  [disabled]="!currentTxnStatus.saveEnabled" style="position:relative;top:2px;"></button>
        </div>
        <div class="p-grid dba-info">
          <div class="p-col-12 p-md-6 p-lg-6 dba-info-primary">
            <div class="p-grid">
              <div class="p-col-12 p-md-4 p-lg-4">
                <label>DBA Name*</label></div>
              <div class="p-col-12 p-md-8 p-lg-8">
                <div>
                  <input pInputText name="dbaName" type="text" [size]="Validation.DialogTextSize" [maxlength]="Validation.nameMaxLength"
                         [(ngModel)]="partner.dbaName"
                         [disabled]="!currentTxnStatus.saveEnabled" required>
                </div>
              </div>
            </div>

            <div *ngIf="partner.partnerAddresses">
              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Address Name*</label></div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <div>
                    <input pInputText name="dbaAddrName" type="text" [size]="Validation.DialogTextSize" [maxlength]="Validation.nameMaxLength"
                           [(ngModel)]="dbaPartnerAddress.addrName"
                           required>
                  </div>
                </div>
              </div>

              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Address*</label></div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <div>
                    <input pInputText name="dbaAddressln1" type="text" [size]="Validation.DialogTextSize" [maxlength]="Validation.nameMaxLength"
                           [(ngModel)]="dbaPartnerAddress.addrLn1"
                           [disabled]="!currentTxnStatus.saveEnabled"
                           required>
                  </div>
                  <div>
                    <input pInputText name="dbaAddressln2" type="text" class="text-wrapper-address" [size]="Validation.DialogTextSize" [maxlength]="Validation.nameMaxLength"
                           style="margin-top:5px;"
                           [(ngModel)]="dbaPartnerAddress.addrLn2"
                           [disabled]="!currentTxnStatus.saveEnabled">
                  </div>
                </div>
              </div>

              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>City*</label></div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <input pInputText name="dbaCity" type="text" [size]="Validation.DialogTextSize" [maxlength]="Validation.nameMaxLength"
                         [(ngModel)]="dbaPartnerAddress.city"
                         [disabled]="!currentTxnStatus.saveEnabled"
                         requied>
                </div>
              </div>

              <div *ngIf="dbaPartnerAddress.country===CountryType.USA" class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>State*</label></div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <p-dropdown name="dbaState" [placeholder]="PrimeNgConfig.DropdownPlaceholder"
                              [options]="stateCodesDropdown" filter="true"
                              [(ngModel)]="dbaPartnerAddress.stateCode"
                              [disabled]="!currentTxnStatus.saveEnabled"
                              required></p-dropdown>
                </div>
              </div>
              <div *ngIf="dbaPartnerAddress.country!==CountryType.USA" class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>State/Province/Region*</label></div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <input pInputText name="dbaRegion" type="text" pKeyFilter="alpha" maxlength="15"
                         [(ngModel)]="dbaPartnerAddress.stateCode" required>
                </div>
              </div>
            </div>
          </div>
          <div class="p-col-12 p-md-6 p-lg-6 dba-info-secondary">
            <div class="p-grid">
              <div class="p-col-12 p-md-4 p-lg-4">
                <label>Zip Code*</label></div>
              <div class="p-col-12 p-md-8 p-lg-8">
                <div>
                  <input *ngIf="dbaPartnerAddress.country===CountryType.USA"
                         pInputText name="dbaZip" type="text" [pattern]="UsZipCodePattern" [minlength]="Validation.UsZipMinLength" [maxlength]="Validation.UsZipMaxLength"
                         [(ngModel)]="dbaPartnerAddress.postalCode"
                         [disabled]="!currentTxnStatus.saveEnabled"
                         required>
                  <input *ngIf="dbaPartnerAddress.country!==CountryType.USA"
                         pInputText name="dbaPostal" type="text" [pattern]="AlphaNumDashRegex" [minlength]="Validation.NonUsZipMinLength" [maxlength]="Validation.NonUsZipMaxLength"
                         [(ngModel)]="dbaPartnerAddress.postalCode"
                         [disabled]="!currentTxnStatus.saveEnabled">
                </div>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-12 p-md-4 p-lg-4">
                <label>Country</label></div>
              <div class="p-col-12 p-md-8 p-lg-8">
                <p-dropdown name="dbaCountry" [placeholder]="PrimeNgConfig.DropdownPlaceholder"
                            [options]="countryCodesDropdown" filter="true"
                            [(ngModel)]="dbaPartnerAddress.country"
                            [disabled]="!currentTxnStatus.saveEnabled"
                            required></p-dropdown>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-12 p-md-4 p-lg-4">
                <label>Main Phone*</label></div>
              <div class="p-col-12 p-md-8 p-lg-8" [ngStyle]="{'pointer-events':(!currentTxnStatus.saveEnabled) ? 'none' : 'auto' }">
                <app-international-phone-number name="dbaMainPhone" [(ngModel)]="dbaPartnerAddress.mainPhone"
                                                required>
                </app-international-phone-number>
              </div>
            </div>
            <div class="p-grid">
              <div class="p-col-12 p-md-4 p-lg-4">
                <label>Fax Phone </label></div>
              <div class="p-col-12 p-md-8 p-lg-8" [ngStyle]="{'pointer-events':(!currentTxnStatus.saveEnabled) ? 'none' : 'auto' }">
                <app-international-phone-number name="dbaFaxPhone" [(ngModel)]="dbaPartnerAddress.faxPhone">
                </app-international-phone-number>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-grid">
        <div *ngIf="orgType===OrgType.Vendor" class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label>Allow Time Sheet Access </label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              <p-checkbox name="timesheetAccess" binary="true" [style]="{'padding':'8px 0 0 0'}"
                          [(ngModel)]="partner.allowTimesheetAccess"
                          [disabled]="!currentTxnStatus.saveEnabled"></p-checkbox>
            </div>
          </div>
        </div>
        <div *ngIf="orgType===OrgType.Vendor " class="p-col-12 p-md-6 p-lg-6">
          <div class="p-grid">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label>Allow Expense Report Access </label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              <p-checkbox name="expenseAccess" binary="true" [style]="{'padding':'8px 0 0 0'}"
                          [(ngModel)]="partner.allowExpenseReportAccess"
                          [disabled]="!currentTxnStatus.saveEnabled"></p-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <!--datatable- show only for customer and vendor UI-->
  <p-dialog *ngIf="addressToEdit&&displayDialog" [(visible)]="displayDialog"
            header="Add or Modify Address" [modal]="true" [responsive]="true" [style]="PrimeNgConfig.DialogStyle40" [contentStyle]="{'overflow-y':'auto'}">
    <form #dialogForm="ngForm">
      <p *ngIf="errorMessageForSameAddressCombination" class="growl-submit">{{errorMessageForSameAddressCombination}}</p>
      <p *ngIf="errorMessageForSameAddressType" class="growl-submit">{{errorMessageForSameAddressType}}</p>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Company Name</label></div>
        <div class="p-col-12 p-md-8 p-lg-8" style="margin-top:12px;">{{partner.businessName}} </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Address Type*</label></div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="addressType" [placeholder]="PrimeNgConfig.DropdownPlaceholder"
                      [options]="addrTypeDropDown"
                      [(ngModel)]="addressToEdit.addrType"
                      (onChange)="onChangeAddressType($event.value)"
                      [disabled]="disabledIfBillToAddressType" required></p-dropdown>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Address Name*</label></div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText name="addressName" type="text" [size]="Validation.DialogTextSize" [maxlength]="Validation.AddrMaxLength"
                 [(ngModel)]="addressToEdit.addrName"
                 (blur)="onBlurCheckAddressName(addressToEdit)"
                 [disabled]="disableAddressName" required>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Address*</label></div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText name="addrLn1" type="text" [size]="Validation.DialogTextSize" [maxLength]="Validation.AddrMaxLength"
                 [(ngModel)]="addressToEdit.addrLn1"
                 [disabled]="disabledIfBillToAddressType" required>
          <br>
          <input pInputText name="addrLn2" type="text" [size]="Validation.DialogTextSize" [maxlength]="Validation.AddrMaxLength" style="margin-top:5px;"
                 [(ngModel)]="addressToEdit.addrLn2"
                 [disabled]="disabledIfBillToAddressType">
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>City*</label></div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText name="city" type="text" [size]="Validation.DialogTextSize" [maxlength]="Validation.CityMaxLength"
                 [(ngModel)]="addressToEdit.city"
                 [disabled]="disabledIfBillToAddressType" required>
        </div>
      </div>
      <div *ngIf="addressToEdit.country===CountryType.USA" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>State*</label></div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="state" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [style]="{'width':'50%'}"
                      [options]="stateCodesDropdown" filter="true"
                      [(ngModel)]="addressToEdit.stateCode"
                      [disabled]="disabledIfBillToAddressType" required></p-dropdown>
        </div>
      </div>
      <div *ngIf="addressToEdit.country!==CountryType.USA" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>State/Province/Region*</label></div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText name="region" type="text" pKeyFilter="alpha" [maxlength]="Validation.StateNameMaxLength" [style]="{'width':'50%'}"
                 [(ngModel)]="addressToEdit.stateCode"
                 [disabled]="disabledIfBillToAddressType" required>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Zip*</label></div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input *ngIf="addressToEdit.country===CountryType.USA"
                 pInputText name="zip" type="text" [pattern]="UsZipCodePattern" [minlength]="Validation.UsZipMinLength" [maxlength]="Validation.UsZipMaxLength"
                 [(ngModel)]="addressToEdit.postalCode"
                 [disabled]="disabledIfBillToAddressType" required>
          <input *ngIf="addressToEdit.country!==CountryType.USA"
                 pInputText name="postal" type="text" [pattern]="AlphaNumDashRegex" [minlength]="Validation.NonUsZipMinLength" [maxlength]="Validation.NonUsZipMaxLength"
                 [(ngModel)]="addressToEdit.postalCode"
                 [disabled]="disabledIfBillToAddressType" required>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Country*</label></div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="country" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [style]="{'width':'50%'}"
                      [options]="countryCodesDropdown" filter="true"
                      [(ngModel)]="addressToEdit.country"
                      [disabled]="disabledIfBillToAddressType" required></p-dropdown>
        </div>
      </div>
      <div class="p-grid" [ngStyle]="{'pointer-events':(disabledIfBillToAddressType) ? 'none' : 'auto' }">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Main Phone*</label></div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <app-international-phone-number name="mainPhone" [(ngModel)]="addressToEdit.mainPhone" required></app-international-phone-number>
        </div>
      </div>
      <div class="p-grid" [ngStyle]="{'pointer-events':(disabledIfBillToAddressType) ? 'none' : 'auto' }">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Fax Phone </label></div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <app-international-phone-number name="faxPhone" [(ngModel)]="addressToEdit.faxPhone"></app-international-phone-number>
        </div>
      </div>

    </form>
    <p-footer>
      <div class="p-col-12" style="text-align:right;">
        <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Close"
                (click)="closeDialog()"></button>
        <button *ngIf="!addressToEdit.id"
                pButton type="button" class="button-action" icon="fa fa-check" label="Add"
                (click)="onClickAddAddress(addressToEdit)"
                [disabled]="!dialogForm.form.valid || errorMessageForSameAddressType || errorMessageForSameAddressCombination"></button>
        <button *ngIf="addressToEdit.id"
                pButton type="button" class="button-action" icon="fa fa-check" label="Update"
                (click)="onClickUpdateAddress(addressToEdit, partner)"
                [disabled]="!dialogForm.form.valid || errorMessageForSameAddressType || errorMessageForSameAddressCombination || !currentTxnStatus.saveEnabled"></button>
      </div>
    </p-footer>
  </p-dialog>

  <p-confirmDialog></p-confirmDialog>

  <div *ngIf="partner" style="clear:both!important;margin-top:20px;">
    <div class="p-col-12">

      <h4 style="text-align:left;">Manage Addresses</h4>

      <app-data-table [columns]="tableColumns" [value]="partner.partnerAddresses" sortField="name" [sortOrder]="PrimeNgConfig.TableAscSortOrder"
                      [leftCaptionTemplate]="leftCaptionTemplate" [rightCaptionTemplate]="rightCaptionTemplate" [bodyTemplate]="bodyTemplate">

        <ng-template #leftCaptionTemplate>
          <div class="billingAddressSameAsMainAddress" style="float:left;">
            <p-checkbox name="billingAddressSameAsMainAddress" binary="true" label="Billing address same as Main"
                        [(ngModel)]="partner.billingAddressSameAsMainAddress"
                        (onChange)="onChangeAddBillingAddressIfSameAsMain()"
                        [disabled]="!currentTxnStatus.saveEnabled"></p-checkbox>
          </div>
        </ng-template>

        <ng-template #rightCaptionTemplate>
          <button pButton type="button" class="add wrapper action-secondary" icon="fa fa-plus" iconPos="left" label="Add Address"
                  (click)="onClickAddAddressDialog()"
                  [disabled]="!generalForm.form.valid || !currentTxnStatus.saveEnabled">
          </button>
        </ng-template>

        <ng-template #bodyTemplate let-row="row" let-columns="columns">
          <tr>
            <td *ngFor="let col of columns" [ngSwitch]="col.field">
              <span *ngIf="row?.addrType !== AddressType.Main" class="p-cell">
                <div *ngSwitchCase="'addrType'">
                  <span>{{row.addrType | stringReplace: LabelChangeAddressType}}</span>
                  <button *ngIf="row.addrType===AddressType.ShipTo && !row.taxExist"
                          pButton class="icon-negative" icon="fa fa-exclamation-triangle" pTooltip="Address Error"
                          (click)="showAddressError()">
                  </button>
                </div>
                <div *ngSwitchCase="'addrLn1'"> {{row.addrLn1}} {{row.addrLn2}} </div>
                <div *ngSwitchCase="'action'" text-align="center">
                  <button pButton type="button" class="icon-button icon-action" icon="fa fa-pencil" pTooltip="Select and update existing Earnings Details" tooltipPosition="top"
                          (click)="onClickEditAddressDialog(row)"
                          [disabled]="!currentTxnStatus.saveEnabled">
                  </button>
                  <button pButton type="button" class="icon-button icon-negative" icon="fa fa-trash" pTooltip="Select and delete earnings details" tooltipPosition="top"
                          (click)="onClickDeleteAddress(row)"
                          [disabled]="!currentTxnStatus.saveEnabled">
                  </button>
                </div>
                <div *ngSwitchDefault>
                  <app-data-table-renderer [col]="col" [row]="row"></app-data-table-renderer>
                </div>
              </span>
            </td>
          </tr>
        </ng-template>
      </app-data-table>

    </div>
    <div style="clear:both;"></div>
  </div>

  <div class="org-action-buttons p-grid" style="margin-top:10px;">
    <div class="p-col-12 p-md-6 p-lg-6" style="text-align:left;">
      <button pButton type="button" class="action-secondary" icon="fa fa-arrow-circle-left" label="Return To Summary"
              [routerLink]="[RouteLink.TradingPartnerSummary,orgType]">
      </button>
    </div>
    <div class="p-col-12 p-md-6 p-lg-6" style="text-align:right;">

      <button pButton type="button" class="button-action" icon="fa fa-check" label="Save"
              (click)="onClickSavePartner(partner)"
              [disabled]="!generalForm.form.valid || !currentTxnStatus.saveEnabled">
      </button>

      <button *ngIf="partner && partner.currentStatusName===ApprovalStatusType.Completed"
              pButton type="button" class="button-action" icon="fa fa-check" label="Edit"
              (click)="onClickEditPartner()"
              [disabled]="!generalForm.form.valid">
      </button>

      <!--Removing Ach validation length because the disbursement type can be check-->
      <button *ngIf="orgType===OrgType.Vendor && currentTxnStatus.submitEnabled"
              pButton type="button" class="button-action" icon="fa fa-check" label="Submit"
              (click)="onClickSubmitPartnerForApproval()"
              [disabled]="!partner?.id || partner?.partnerPaymentSettings?.length===0 || !partner?.hasMainContact || !generalForm.form.valid">
      </button>
      <button *ngIf=" orgType===OrgType.Customer && currentTxnStatus.submitEnabled"
              pButton type="button" class="button-action" icon="fa fa-check" label="Submit"
              (click)="onClickSubmitPartnerForApproval()"
              [disabled]="!partner?.id || (!partner?.governmentAgency && partner?.partnerPaymentSettings?.length===0) ||
              !partner?.hasMainContact || !partner?.hasBillingContact || !partner?.hasBillToAddress || !generalForm.form.valid">
      </button>
      <button *ngIf="orgType===OrgType.Vendor && currentTxnStatus.submitEnabled &&
              (!partner?.hasMainContact || (!partner?.governmentAgency && partner?.partnerPaymentSettings?.length===0))"
              pButton type="button" class="help-tip" icon="fa fa-warning" pTooltip="To Submit, please complete Main contact and Payment Info" tooltipPosition="top">
      </button>
      <button *ngIf="orgType===OrgType.Customer && currentTxnStatus.submitEnabled &&
              (!partner?.hasMainContact || !partner?.hasBillingContact || !partner?.hasBillToAddress ||
               (!partner?.governmentAgency && partner?.partnerPaymentSettings?.length===0))"
              pButton type="button" class="help-tip" icon="fa fa-warning" pTooltip="To Submit, please complete Bill-To address, Main contact, Billing contact, and Payment Info" tooltipPosition="top">
      </button>
    </div>
    <div style="clear:both;"></div>
  </div>

  <p-dialog *ngIf="showError" [(visible)]="showError"
            header="Address Error" [modal]="true" [responsive]="true" [style]="PrimeNgConfig.DialogStyle65" showEffect="fade">
    <div header="Standard Terms">
      Need to set up tax for this SHIP_TO address.
    </div>
    <p-footer>
      <div style="text-align:right;margin:10px;">
        <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Close" (click)="showError=false"></button>
      </div>
    </p-footer>
  </p-dialog>
</section>

<p-overlayPanel [style]="{'width':'500px'}" [showCloseIcon]="true" [dismissable]="true" #op1 [appendTo]="op1">
  <div class="p-grid">
    <div class="p-col-12 p-md-3 p-lg-3">
      <label> ACH Customer Id </label>
    </div>
    <div class="p-col-12 p-md-9 p-lg-9">
      {{partner?.achCustomerDetails?.customerId}}
    </div>
    <div class="p-col-12 p-md-3 p-lg-3">
      <label> ACH Customer Status</label>
    </div>
    <div class="p-col-12 p-md-9 p-lg-9">
      {{partner?.achCustomerDetails?.status}}
    </div>
    <div class="p-col-12 p-md-3 p-lg-3">
      <label> ACH Customer Type </label>
    </div>
    <div class="p-col-12 p-md-9 p-lg-9">
      {{partner?.achCustomerDetails?.customerType}}
    </div>
  </div>
</p-overlayPanel>
